import { render } from "./UserStatistics.vue?vue&type=template&id=ea3d5b20&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"

import "./UserStatistics.vue?vue&type=style&index=0&id=ea3d5b20&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3d5b20"]])

export default __exports__